<template lang="pug">
	
	.political
		flags-overlay(ref='flags')
		political-intro.political-section
		political-slider.political-section
		political-presentation.political-section
		political-car.political-section

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import PoliticalIntro from './_components/political-intro.vue'
	import PoliticalSlider from './_components/political-slider.vue'
	import PoliticalPresentation from './_components/political-presentation.vue'
	import PoliticalCar from './_components/political-car.vue'
	import Background from '../../components/background.vue'
	import Scrollable from '../../abstracts/scrollable'
	import FlagsOverlay from '../../components/flags-overlay.vue'
	import Globals from '~utils/Globals.js'

  	@Component({
		name: 'Political',
		components: {FlagsOverlay, Background,PoliticalIntro, PoliticalSlider, PoliticalPresentation, PoliticalCar  }
	})

	class Political extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

			this.scroller.register(this)
		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$flagsOverlay = this.$el.querySelector('.flags-overlay')

		}

		initTimeline () {
			super.initTimeline()
		}

		raf (y) {
			super.raf(y)	
		}

		initIntervals () {
			
			const w = Globals.width
			const h = Globals.height

			this.tl = new TimelineMax({paused: true})
			this.tl.fromTo(this.$flagsOverlay,1,{y:0},{y:this.bounds.height - h, ease: Power0.easeNone},0)
			
		}

		raf (y) {
			if(!this.scroller.isInViewport(this.bounds.top,this.bounds.height) ) return
			this.perc = this.scroller.getPerc(this.boundsAnim, y)		
			this.tl && this.tl.progress(this.perc)

			this.$refs.flags && this.$refs.flags.update(Math.abs(y))
		}

		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.bounds.height - Globals.height
			}

			this.tl && this.tl.progress(this.scroller.getPerc(this.boundsAnim, Globals.scroll))

			this.initIntervals()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Political

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.political
		width 100%
		background $COLOR_BLUE
		position relative

		.political-section
			position relative
			z-index 30

		.flags-overlay
			position absolute
			top 0
			left 0
			z-index 50

</style>


// WEBPACK FOOTER //
// political.vue?4aa638db